import { useStore } from '@nanostores/react';
import { useAuth } from '@/services/auth';
import { billing } from '@/services/billing';
import { buildCouponBanner, type CouponBannerModel } from '../utils/coupon-banner';

/**
 * The discount the account's coupon gives it, as the banner states it, or null when there is none.
 *
 * The billing shell loads the profile with `includeCoupons`, so every tab under it can read the
 * coupon.
 */
export function useCouponBanner(): CouponBannerModel | null {
  const { account } = useAuth();

  const coupon = useStore(billing.coupon);
  const subscription = useStore(billing.subscription);
  const couponEndsAt = useStore(billing.couponEndsAt);
  const isSubscriptionActive = useStore(billing.isSubscriptionActive);
  // The plain plan name. `billing.planName` decorates it with the account status — "Essentials Past
  // Due" — which must not go in the middle of a sentence.
  const planName = useStore(billing.planNameShortened);

  return buildCouponBanner({
    isSubscriptionActive,
    coupon,
    subscription,
    planName,
    couponEndsAt,
    promoCodes: account?.promo_codes,
  });
}
